import { getAuthToken } from '@/assets/js/Authentication'
import HttpRequest from './HttpRequest'

class CareLabelProvider extends HttpRequest {
  constructor () {
    super(`${process.env.VUE_APP_MER_API}/care-label`)
  }

  pagination (query) {
    this.setHeader(getAuthToken())
    return this.get('/', query)
  }

  create (payload) {
    this.setHeader(getAuthToken())
    return this.post('/', payload)
  }

  updateById (id, payload) {
    this.setHeader(getAuthToken())
    return this.patch(`/${id}`, payload)
  }

  deleteById (id) {
    this.setHeader(getAuthToken())
    return this.delete(`/${id}`)
  }

  getAll () {
    this.setHeader(getAuthToken())
    return this.get('/all/items')
  }

  getById (id) {
    this.setHeader(getAuthToken())
    return this.get(`/${id}`)
  }
}

export default CareLabelProvider
